import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/tax-numbers.actions';
import { ITaxNumbersResponse } from '../models/tax-numbers.model';

export const taxNumbersFeatureKey = 'taxNumbers';

export interface TaxNumbersState {
  loading: boolean;
  error: any;
  data: ITaxNumbersResponse | null;
}

export const initialState: TaxNumbersState = {
  loading: false,
  error: null,
  data: null
};

export const reducer = createReducer(
  initialState,
  on(actions.loadTaxNumbers, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(actions.loadTaxNumbersSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: response,
    error: null
  })),
  on(actions.loadTaxNumbersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export const getTaxNumbers = (state: TaxNumbersState) => state.data;